const Loader = ({ isprimary }) => {
  return (
    <div
      className={`animate-spin rounded-full h-6 w-6 border-b-2  ${
        isprimary ? "border-primary" : "border-white"
      }`}
    ></div>
  );
};
export default Loader;
